export class SignalService
{
    static _keyword_list = [
                    'amenities',
                    'agreement',
                    'access',
                    'about',
                    'about-us',
                    'account',
                    'accounts',
                    'admission',
                    'admissions',
                    'admin',
                    'administrator',
                    'administrators',
                    'appointment',
                    'appointments',
                    'admins',
                    'advice',
                    'advices',
                    'advisor',
                    'advisors',
                    'aid',
                    'all',
                    'alerts',
                    'alert',
                    'app',
                    'application',
                    'applications',
                    'apply',
                    'apps',
                    'article',
                    'articles',
                    'award',
                    'awards',
                    'benefit',
                    'benefits',
                    'billing',
                    'billings',
                    'buy',
                    'business',
                    'businesses',
                    'blog',
                    'blogs',
                    'book',
                    'book-now',
                    'booking',
                    'brand',
                    'brands',
                    'bundle',
                    'bundles',
                    'call',
                    'calls',
                    'campaign',
                    'campaigns',
                    'chat',
                    'chats',
                    'card',
                    'cards',
                    'career',
                    'careers',
                    'cart',
                    'carts',
                    'case-studies',
                    'case-study',
                    'categories',
                    'category',
                    'checkout',
                    'checkouts',
                    'checklist',
                    'checklists',
                    'credits',
                    'client',
                    'client-list',
                    'client-stories',
                    'clients',
                    'channel',
                    'channels',
                    'catalog',
                    'catalogs',
                    'collection',
                    'collections',
                    'communities',
                    'community',
                    'confirmation',
                    'contact',
                    'corporate',
                    'contact-us',
                    'contacts',
                    'copyright',
                    'copyrights',
                    'complete',
                    'coupon',
                    'coupons',
                    'course',
                    'courses',
                    'custom',
                    'customer',
                    'customers',
                    'dashboard',
                    'data',
                    'data-privacy',
                    'delete',
                    'delivery',
                    'default',
                    'detail',
                    'details',
                    'demo',
                    'download',
                    'directory',
                    'explore',
                    'edit',
                    'enroll',
                    'email',
                    'experience',
                    'exam',
                    'exams',
                    'employee',
                    'employees',
                    'extra',
                    'event',
                    'events',
                    'faq',
                    'faqs',
                    'fulfillment',
                    'frequently-asked-questions',
                    'feedback',
                    'free',
                    'form',
                    'forms',
                    'forum',
                    'get-started',
                    'gethelp',
                    'gift',
                    'gift-card',
                    'gift-cards',
                    'gifts',
                    'help',
                    'help-center',
                    'hire',
                    'hires',
                    'history',
                    'hours',
                    'home',
                    'how-it-works',
                    'how-to',
                    'index',
                    'index.php',
                    'industries',
                    'industry',
                    'ig',
                    'info',
                    'inform',
                    'information',
                    'invoice',
                    'invoices',
                    'item',
                    'items',
                    'integrations',
                    'integration',
                    'your',
                    'job',
                    'jobs',
                    'legal',
                    'list',
                    'lists',
                    'live',
                    'learn',
                    'location',
                    'locations',
                    'login',
                    'logout',
                    'join',
                    'magazine',
                    'main.php',
                    'message',
                    'media',
                    'member',
                    'members',
                    'membership',
                    'memberships',
                    'moreinfo',
                    'more-info',
                    'mission',
                    'news',
                    'newsletter',
                    'optin',
                    'offer',
                    'offers',
                    'order',
                    'order-pay',
                    'order-received',
                    'orders',
                    'office',
                    'offices',
                    'onboarding',
                    'onboard',
                    'our',
                    'our-company',
                    'our-team',
                    'our-values',
                    'partner',
                    'partners',
                    'partnership',
                    'pack',
                    'packs',
                    'page',
                    'pages',
                    'password',
                    'pay',
                    'payment',
                    'payment-method',
                    'payments',
                    'platform',
                    'platforms',
                    'place',
                    'places',
                    'plans',
                    'plus',
                    'podcast',
                    'podcasts',
                    'policy',
                    'portal',
                    'portfolio',
                    'practice',
                    'practices',
                    'press',
                    'press-release',
                    'press-releases',
                    'present',
                    'presents',
                    'profile',
                    'profiles',
                    'program',
                    'programs',
                    'privacy',
                    'privacy-policy',
                    'product',
                    'product-category',
                    'products',
                    'promo',
                    'promos',
                    'provider',
                    'providers',
                    'purchase',
                    'purchases',
                    'quote',
                    'quotes',
                    'rate',
                    'rates',
                    'report',
                    'reports',
                    'receipt',
                    'receipts',
                    'recommendation',
                    'recommendations',
                    'relationships',
                    'referral',
                    'referrals',
                    'registrar',
                    'register',
                    'registration',
                    'renew',
                    'renewal',
                    'request',
                    'request-quote',
                    'results',
                    'result',
                    'reset',
                    'resources',
                    'retail',
                    'return',
                    'review',
                    'reviews',
                    'rewards',
                    'sell',
                    'sale',
                    'sales',
                    'search',
                    'special',
                    'specials',
                    'off',
                    'unsubscribe',
                    'uncategorized',
                    'discount',
                    'device',
                    'devices',
                    'survey',
                    'service',
                    'services',
                    'shipping',
                    'schedule',
                    'show',
                    'shop',
                    'shop-all',
                    'shops',
                    'settings',
                    'setting',
                    'step',
                    'steps',
                    'sign-in',
                    'signin',
                    'sitemap',
                    'solution',
                    'solutions',
                    'sync',
                    'store',
                    'stores',
                    'stage',
                    'stages',
                    'subscribe',
                    'subscription',
                    'subscriptions',
                    'success',
                    'success-stories',
                    'success-story',
                    'support',
                    'team',
                    'teams',
                    'teamwork',
                    'term',
                    'terms',
                    'test',
                    'tests',
                    'term-conditions',
                    'thank-you',
                    'thanks',
                    'update',
                    'updates',
                    'user',
                    'users',
                    'view',
                    'views',
                    'video',
                    'videos',
                    'quiz',
                    'quizes',
                    'webinar',
                    'webinars',
                    'welcome',
                    'watch',
                    'workshop',
                    'wishlist']

    static getSignalUrl(path)
    {
        if(path == "" || path== "/")
        {
            return "home_page";
        }
        
        let pathname = null;
        if(path == null)
        {
            pathname = window.location.pathname;
        }
        else
        {
            pathname = path;
        }
        if(pathname == "/")
        {
            return "home_page";
        }

        let path_parts = pathname.split('/');

        let signalUrlParts = []
        for(const index in path_parts)
        {
            let path_part = path_parts[index]
            if(path_part == "")
            {
                continue;
            }
            let full_matching = null;
            let partial_matching_results = [];

            for (const keyword of this._keyword_list) 
            {
                
                if(keyword == path_part)
                {
                    full_matching = keyword;
                    break;
                }
                if(path_part.includes(keyword))
                {
                    if (keyword.length == 2)
                    {
                        continue;
                    }
                    partial_matching_results.push(keyword);
                }

            }

            if(full_matching != null)
            {
                signalUrlParts.push(full_matching)
                continue;
            }

            if(partial_matching_results.length == 0)
            {
                signalUrlParts.push("other");
            }

            partial_matching_results = this.getUniqueKeywords(partial_matching_results);
            
            let matchingResult = "";
            for (const value of partial_matching_results)
            {
                if(matchingResult == "")
                {
                    matchingResult = value;
                }
                else
                {
                    matchingResult += "_" + value;
                }
            }
            signalUrlParts.push(matchingResult);
        }

        let signalUrl = "";
        for (const signalUrlPart of signalUrlParts)
        {
            if(signalUrlPart == "")
            {
                continue;
            }
            if(signalUrl == "")
            {
                signalUrl = signalUrlPart;
            }
            else
            {
                signalUrl += "/" + signalUrlPart;
            }
        }
        if(signalUrl == "")
        {
            signalUrl = "none";
        }
        if(signalUrl.includes("."))
        {
            signalUrl = signalUrl.replace(".","_");
        }
        return signalUrl
    }

    static getUniqueKeywords(keywords)
    {

        let processedKeywords = []
        
        let counter = 0;
        while(counter < 20)
        {
            let somethingIncludes = false;

            for(const outterKeyword of keywords)
            {
                let innerIsAdded = false;
                for(const innerKeyword of keywords)
                {
                    if(outterKeyword == innerKeyword)
                    {
                        continue;
                    }
                    if(innerKeyword.includes(outterKeyword))
                    {
                        processedKeywords.push(innerKeyword);
                        innerIsAdded = true;
                        somethingIncludes = true;
                    }
                }
                
                if(innerIsAdded == false)
                {
                    processedKeywords.push(outterKeyword);
                }

            }

            var set = new Set(processedKeywords);
            keywords = [...set];

            if(somethingIncludes == false)
            {
                break;
            }
            counter += 1;
        }
        return keywords.sort();
    }

    static getSignalType(signalUrl, objectId, objectName, objectClass, actionType)
    {
        if (objectId == null || objectId == "")
        {
            objectId = "none";
        }
        if (objectName == null || objectName == "")
        {
            objectName = "none";
        }
        if(objectClass == null || objectClass == "")
        {
            objectClass = "none";
        }
        try
        {
            objectId = objectId.replace(" ", "_").toLowerCase();
            objectName = objectName.replace(" ", "_").toLowerCase();
            objectClass = objectClass.replace(" ", "_").toLowerCase();
        }
        catch(ex)
        {
            objectId = "none";
            objectName = "none";
            objectClass = "none";
        }
        let signalType = signalUrl + "/" +objectId + "/" + objectName + "/" + objectClass + "/" + actionType;
        if(signalType.includes("."))
        {
            signalType = signalType.replace(".","_");
        }
        return signalType;
    }
}




